import { Filter } from '@bingads-webui/listener';
import type { InstrumentationLog } from '../types';

export class UnloadLogFilter extends Filter {
  check(log: InstrumentationLog) {
    return !(log.activityName === 'RunAriaV2UnloadHandler' &&
            log.scenarioName === 'PageUnload' &&
            !log.excludeFromLocalStorage);
  }
}
